export const TEMPLATE_PAGE_SIZE = 10;

export const getTemplatePageParams = (
  page: number,
  pageSize = TEMPLATE_PAGE_SIZE,
  query = '',
) => ({
  p: page,
  s: pageSize,
  ...(query ? { q: query } : {}),
});

export const getTemplatesQueryKey = (page: number, pageSize: number, query = '') => [
  'templates',
  { page, pageSize, query },
] as const;

export const getTotalPages = (total: number) => Math.ceil(total / TEMPLATE_PAGE_SIZE);

export const getPageAfterDeletion = (
  currentPage: number,
  recordsOnPage: number,
): number => (currentPage > 1 && recordsOnPage === 1 ? currentPage - 1 : currentPage);
